import React from "react";
import { useDraggable } from "@dnd-kit/core";

interface DraggableProps {
  id: string;
  header: string;
  value: string;
  // Optional human-friendly text shown in the drag overlay. Defaults to `value` when omitted,
  // letting the payload (`value`) differ from what the user sees (e.g. carry a block id but
  // display the security name).
  label?: string;
  children: React.ReactNode;
}

const Draggable: React.FC<DraggableProps> = ({
  id,
  header,
  value,
  label,
  children,
}) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id,
    data: { header, value, label },
  });

  return (
    <div ref={setNodeRef} {...listeners} {...attributes}>
      {children}
    </div>
  );
};

export default Draggable;
